export enum TransportMethod {
  CASH = 'CASH',
  TICKETS = 'TICKETS',
  ENTITY_PROVIDED = 'ENTITY_PROVIDED',
}
